import React, {useState} from 'react'
import {Card, Row, Col } from 'react-bootstrap'
import SketchfabSingleModel from '../../common/SketchfabSingleModel'

const SketchfabChair = () => {
    const [modelIds, setModelIds] = useState("3516a7757ab14cef91f1e27422700d09");

  return (
    <>
    <Card className='no-border rounded-0 container sketchfab-chair-section'>
        <Row>
            <Col sm={{span:12, offset:0}} md={{span:5, offset:0}} id="first" className="no-padding-x">
                <div className="sketchfab-player-container">
                    <div className="sketchfab-player" style={{display: (modelIds === "3516a7757ab14cef91f1e27422700d09") ? "block" : "none"}}> 
                        <SketchfabSingleModel modelId="3516a7757ab14cef91f1e27422700d09" />
                    </div>
                    <div className="sketchfab-player" style={{display: (modelIds === "045ed432df124b1496e19dfd47779131") ? "block" : "none"}}> 
                        <SketchfabSingleModel modelId="045ed432df124b1496e19dfd47779131" />
                    </div>
                </div>
                <Card.Img className="no-padding-x chair-shadow" src={"/assets/extra-common/chair-section-shadow.png"}  alt="" />
                <Row className="sketchfab-button-section">
                    <Col sm={12} className="thumbnail-location" >
                        <Row>
                            <Col  xs={{span:2, offset:4}} className={(modelIds === "3516a7757ab14cef91f1e27422700d09") ? "t1" : "t2"}> 
                                    <img className='img-fluid thumbnail-icons'  onClick={() => setModelIds("3516a7757ab14cef91f1e27422700d09") } src={"/assets/thumbnails/gaming-chair.png"} alt="" />
                            </Col>
                            <Col  xs={{span:2, offset:0}} className={(modelIds === "045ed432df124b1496e19dfd47779131") ? "t1" : "t2"}> 
                                    <img className='img-fluid thumbnail-icons'  onClick={() => setModelIds("045ed432df124b1496e19dfd47779131") } src={"/assets/thumbnails/reincliner-chair.png"}  alt=""/>
                            </Col>
                        </Row> 
                    </Col>
                </Row>
            </Col>
            <Col sm={{span:12, offset:0}} md={{span:7, offset:0}} id="second" className="">
                <div className="player-details">
                    <p className='player-header'>自宅でARで商品配置を体験</p>
                    <p className='player-desc'>
                    家具などの3D製品モデルを作成すると、ECサイトや ARを通じて購入者が直接製品モデルを見ることができるようになります。ARのリアルタイムレンダリングは、スタジオ撮影の差し替え用モデルのクオリティにはまだ及びませんが、購入者が自分の家に置いたときのイメージをリアルに確認することができます。これにより、お客さまの商品購入の可能性を高め、商品の返品を減らし、お客さまを満足させることができます。
                    </p>
                    <p className='player-scan-desc'>このQRコードをスキャンして、お使いのデバイスでモデルを開き、ARアイコンをタップしてください:</p>
                    <p>
                        <img src={"/assets/thumbnails/" + (modelIds === "3516a7757ab14cef91f1e27422700d09" ? "qrchair.png" : "qrsofa.png")} className="player-scanner" alt=""/>
                    </p>
                    <p className='player-footnote'>
                    これにより、お客さまの商品購入の可能性を高め、商品の返品を減らし、お客さまを満足させることができます。
                     <br /> 
                    <span style={{fontSize: "10px"}}>
                        互換性
                        iPhone
                        iOS 12.1以降が必要です。
                        iPad
                        iPadOS 12.1以降が必要です。
                        Androidスマートフォン／タブレット
                        ARCore 1.9をサポートしたAndroid OS 8.0以降が必要です。
                    </span>
                    </p>
                </div>
            </Col>
        </Row>
    </Card>
    </>
  )
}

export default SketchfabChair
